import TemplateView from '../../../../../../js/TemplateView'
import DropdownDialogWithPointerWrapper from '../../../../../../js/components/DropdownDialogWithPointerWrapper'
import ScrollableContainer from '../../../../../../js/util/ScrollableContainer'
import UsersSelectionDetailedInfoContent from './UsersSelectionDetailedInfoContent'
import $ from 'jquery'

class UsersSelectionDetailedInfo extends TemplateView {

    constructor() {
        super()

        this.state = {
            titleKey: '',
            groups: [],
            users: [],
            groupType: null,
        }

        this.onStateChanged(state => this.usersTooltipContent.setState(state))
    }

    templateHtml() {
        return `<div class='components_usersSelectionDetailedInfo'/>`
    }

    afterRender() {
        this.usersTooltipContent = new UsersSelectionDetailedInfoContent({
            titleKey: this.state.titleKey,
            groups: this.state.groups,
            users: this.state.users,
            groupType: this.state.groupType,
        })

        this.scrollableContainer = new ScrollableContainer(null, this.usersTooltipContent, {
            containerClass: 'usersSelectionDetailedInfoScroll'
        })

        this.dialog = new DropdownDialogWithPointerWrapper({
            dialog: this.scrollableContainer,
            dialogOffsets: {
                top: 10,
                left: 0
            },
            pointerLeftOffset: 0,
        }).init(this.getEl())
    }

    showAt($el) {
        this.dialog.showAt($el, {
            my: 'left top',
            at: 'left bottom',
            collision: 'none',
        })
        this.scrollableContainer.forceUpdate()
    }
}

let instance = null
export const getInstance = () => {
    if (instance === null) {
        instance = new UsersSelectionDetailedInfo().init($('body'))
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/usersDetailedInfo/UsersSelectionDetailedInfo.js